import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { useRequest } from 'hooks';

import { Form, Input, Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';

import { useProgramProfileStore } from 'store/program/useProgramProfileStore';

const Delete = () => {
	// Cache current program's id
	const { id } = useParams();

	// Use router's history
	const history = useHistory();

	// Use program's profile store
	const original = useProgramProfileStore(state => state.program);

	// Store request
	const [[progress], request] = useRequest('delete', `programs/${id}`);

	// Store delete data
	const [data, setData] = useState({
		title: ''
	});

	// Handle input value change
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handles form's onSubmit event
	// @event: object | onSubmit event
	const onSubmit = async event => {
		event.preventDefault();

		// Try to update program's data
		const [success, error] = await request(data);

		// Redirect on success
		if (success) return history.push('/programs');

		// TODO: Think of a better way of handling errors
		if (error) return console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="mt-4 p-4 grid grid-cols-2 gap-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title
				title="Dzēst programmu"
				className="col-span-2 text-xl"
			/>

			<Input
				type="text"
				name="title"
				label="Nosaukums"
				value={data.title}
				placeholder={original.title}
				onChange={onChange}
			/>

			<div className="col-span-2 flex justify-end">
				<Button
					submit
					icon="delete"
					value="Dzēst"
					theme="danger"
					progress={progress}
					disabled={original.title !== data.title}
				/>
			</div>
		</Form>
	);

};

export default Delete;
